module.exports = __webpack_public_path__ + "img/home.445e6f51.svg";